import React from "react"
import { ArrowDownIcon } from "../../common/Icons"
import CheckSteps from "../CheckSteps"
import Tooltip from "../../common/Tooltip"
import OnlineButton from "./OnlineButton"
import "./PaymentMethod.css"

const paymentTypes = ["card", "online", "bank", "otc", "cod"]

function CardDetails({ selectedMethod }) {
  return (
    <div className="CardDetails method-account-details">
      <div>
        <span>Mobile Number</span>
        <span>
          {selectedMethod.mobile_country_code}
          {selectedMethod.mobile}
        </span>
      </div>
    </div>
  )
}

function BankDetails({ selectedMethod }) {
  return (
    <div
      className={`BankDetails
      ${(selectedMethod &&
        selectedMethod.qr_code &&
        selectedMethod.qr_code !== "" &&
        "method-account-details-qr") ||
        "method-account-details"}`}
    >
      {(selectedMethod &&
        selectedMethod.qr_code &&
        selectedMethod.qr_code !== "" && (
          <>
            <div>
              {selectedMethod.bank_account_name && (
                <div>
                  <span>Account Name</span>
                  <span>{selectedMethod.bank_account_name}</span>
                </div>
              )}
              {selectedMethod.bank_account_number && (
                <div>
                  <span>Account Number</span>
                  <span>{selectedMethod.bank_account_number}</span>
                </div>
              )}
              {selectedMethod.bank_account_type && (
                <div>
                  <span>Account Type</span>
                  <span>{selectedMethod.bank_account_type}</span>
                </div>
              )}
            </div>
            {selectedMethod.qr_code &&
              selectedMethod.qr_code !== "" && (
                <img
                  src={selectedMethod.qr_code}
                  alt={selectedMethod.qr_code}
                />
              )}
          </>
        )) || (
        <>
          {selectedMethod.bank_account_name && (
            <div>
              <span>Account Name</span>
              <span>{selectedMethod.bank_account_name}</span>
            </div>
          )}
          {selectedMethod.bank_account_number && (
            <div>
              <span>Account Number</span>
              <span>{selectedMethod.bank_account_number}</span>
            </div>
          )}
          {selectedMethod.bank_account_type && (
            <div className="full">
              <span>Account Type</span>
              <span>{selectedMethod.bank_account_type}</span>
            </div>
          )}
        </>
      )}
    </div>
  )
}

function OTCDetails({ selectedMethod }) {
  return (
    <div className="OTCDetails method-account-details">
      {selectedMethod && (
        <>
          {selectedMethod.business_owner_name && (
            <div>
              <span>Name</span>
              <span>{selectedMethod.business_owner_name}</span>
            </div>
          )}
          {selectedMethod.mobile && (
            <div>
              <span>Mobile Number</span>
              <span>{selectedMethod.mobile}</span>
            </div>
          )}
          {selectedMethod.address_line_1 && (
            <div>
              <span>Address</span>
              <span>{`${selectedMethod.address_line_1} ${selectedMethod.city} ${
                selectedMethod.province
              } ${selectedMethod.country} ${selectedMethod.zipcode}`}</span>
            </div>
          )}
        </>
      )}
    </div>
  )
}

function Online({ selectedMethod }) {
  return (
    <div
      className={`Online ${(selectedMethod &&
        selectedMethod.qr_code &&
        selectedMethod.qr_code !== "" &&
        "method-account-details-qr") ||
        "method-account-details"}`}
    >
      {selectedMethod &&
        ((selectedMethod.gateway_code &&
          (selectedMethod.gateway_code === "PAYP" ||
            selectedMethod.gateway_code === "COINS") && (
            <div>
              <span>Email</span>
              <span className="lower">{selectedMethod.registered_email}</span>
            </div>
          )) || (
          <>
            <div>
              <span>Mobile Number</span>
              <span>
                {selectedMethod.mobile_country_code}
                {selectedMethod.mobile}
              </span>
            </div>
            {selectedMethod.qr_code &&
              selectedMethod.qr_code !== "" && (
                <img
                  src={selectedMethod.qr_code}
                  alt={selectedMethod.qr_code}
                />
              )}
          </>
        ))}
    </div>
  )
}

function MethodDetails({ selectedMethod }) {
  return selectedMethod.payment_type !== "cod" ? (
    <div className="method-details">
      <h3>{selectedMethod.gateway_name}</h3>
      {(selectedMethod.payment_type === "online" &&
        selectedMethod.gateway_code === "PAYM" && (
          <CardDetails selectedMethod={selectedMethod} />
        )) ||
        (selectedMethod.payment_type === "online" && (
          <Online selectedMethod={selectedMethod} />
        )) ||
        (selectedMethod.payment_type === "bank" && (
          <BankDetails selectedMethod={selectedMethod} />
        )) ||
        (selectedMethod.payment_type === "otc" && (
          <OTCDetails selectedMethod={selectedMethod} />
        ))}
    </div>
  ) : (
    <></>
  )
}

class MethodGroups extends React.Component {
  state = { shown: false }

  handleDropdownClick = () => {
    this.setState(state => ({ shown: !state.shown }))
  }

  componentDidMount() {
    const { methodsAvailable, currentMethod } = this.props
    const method = methodsAvailable.find(
      met => String(met.id) === String(currentMethod)
    )
    method && this.setState({ shown: true })
  }

  render() {
    const {
      type,
      label,
      methodsAvailable,
      selectPaymentMethod,
      currentMethod,
      orderData,
      grandTotal,
      setOnlinePaymentDetails,
      salesBeforeTax,
      tax,
      discountAmount,
      shippingRate,
      deliveryData
    } = this.props
    const selectedMethod = methodsAvailable.find(
      method => String(method.id) === String(currentMethod)
    )
    const invalid_cod =
      type === "cod" && (deliveryData && deliveryData.method === "lalamove")
    if (!invalid_cod) {
      return (
        <div
          className={`payment-method-type ${
            this.state.shown ? "shown" : "hidden"
          }`}
          key={type}
        >
          <h2>
            {label}
            <button
              type="button"
              className="dropdown-button"
              onClick={this.handleDropdownClick}
            >
              <ArrowDownIcon />
            </button>
          </h2>
          {this.state.shown && (
            <div className="payment-methods">
              <div className="method-buttons">
                {type !== "card"
                  ? methodsAvailable.map(
                      method =>
                        method.payment_type !== "online" ||
                        method.gateway_code === "GC" ||
                        method.gateway_code === "PAYMP" ? (
                          <button
                            key={method.id}
                            type="button"
                            onClick={selectPaymentMethod}
                            value={method.id}
                            className={`method-button ${method.gateway_code &&
                              method.gateway_code.toLowerCase()} ${(String(
                              method.id
                            ) === String(currentMethod) &&
                              "selected") ||
                              ""}`}
                          >
                            {method.gateway_name}
                          </button>
                        ) : (
                          <OnlineButton
                            key={method.id}
                            orderData={orderData}
                            grandTotal={grandTotal}
                            setOnlinePaymentDetails={setOnlinePaymentDetails}
                            salesBeforeTax={salesBeforeTax}
                            tax={tax}
                            discountAmount={discountAmount}
                            shippingRate={shippingRate}
                            method={method}
                          />
                        )
                    )
                  : methodsAvailable.map(method => (
                      <OnlineButton
                        key={method.id}
                        orderData={orderData}
                        grandTotal={grandTotal}
                        setOnlinePaymentDetails={setOnlinePaymentDetails}
                        salesBeforeTax={salesBeforeTax}
                        tax={tax}
                        discountAmount={discountAmount}
                        shippingRate={shippingRate}
                        method={method}
                      />
                    ))}
              </div>

              {selectedMethod && (
                <MethodDetails selectedMethod={selectedMethod} />
              )}
            </div>
          )}
        </div>
      )
    } else return null
  }
}

function PaymentMethod({
  methods,
  setPaymentMethod,
  currentMethod,
  backHandler,
  steps,
  setSteps,
  createAccount,
  toggleCreateAccount,
  handleConfirmPaymentMethod,
  checkoutMethod,
  confirmingOrder,
  setOnlinePaymentDetails,
  orderData,
  grandTotal,
  salesBeforeTax,
  tax,
  discountAmount,
  shippingRate,
  deliveryData,
  courierPaymentOnly
}) {
  function handleCreateAccountChange() {
    toggleCreateAccount && toggleCreateAccount()
  }

  function selectPaymentMethod(e) {
    const methodID = e.target.value
    setPaymentMethod(methodID)
  }
  return (
    <div className="PaymentMethod">
      <CheckSteps steps={steps} setSteps={setSteps} value="payment" />
      <h1>Payment Method</h1>
      {paymentTypes.map(type => {
        const label =
          (type === "card" && "credit / debit / prepaid cards") ||
          (type === "online" && "online payment") ||
          (type === "bank" && "bank deposit / bank transfer") ||
          (type === "otc" && "over-the-counter") ||
          (type === "cod" && "Cash On Delivery")
        let methodsAvailable = methods
        if (type !== "card") {
          methodsAvailable = methods.filter(
            met => met.payment_type === type && met.gateway_code !== "PAYM"
          )
        } else {
          methodsAvailable = methods.filter(
            met => met.payment_type === "online" && met.gateway_code === "PAYM"
          )
        }

        return (
          (methodsAvailable &&
            methodsAvailable.length > 0 && (
              <MethodGroups
                key={type}
                type={type}
                label={label}
                methodsAvailable={methodsAvailable}
                selectPaymentMethod={selectPaymentMethod}
                currentMethod={currentMethod}
                handleConfirmPaymentMethod={handleConfirmPaymentMethod}
                setOnlinePaymentDetails={setOnlinePaymentDetails}
                setPaymentMethod={setPaymentMethod}
                orderData={orderData}
                grandTotal={grandTotal}
                salesBeforeTax={salesBeforeTax}
                tax={tax}
                discountAmount={discountAmount}
                shippingRate={shippingRate}
                deliveryData={deliveryData}
              />
            )) ||
          null
        )
      })}
      {checkoutMethod === "guest" && (
        <span className="CheckboxInput">
          <input
            type="checkbox"
            name="createAccount"
            id="createAccount"
            onChange={handleCreateAccountChange}
            checked={createAccount}
          />
          <label htmlFor="createAccount">
            <span className="box" />
            <span className="label-text">
              Save my details and create an account
              <Tooltip tooltip="Select this option if you wish to upload your proof of payment later." />
            </span>
          </label>
        </span>
      )}
      {currentMethod && (
        <button
          type="button"
          className="black"
          disabled={confirmingOrder}
          onClick={handleConfirmPaymentMethod}
        >
          {confirmingOrder ? "Confirming..." : "Confirm payment method"}
        </button>
      )}
      {!courierPaymentOnly && (
        <button
          type="button"
          className="gray"
          onClick={backHandler}
          disabled={confirmingOrder}
        >
          Back to shipping method
        </button>
      )}
    </div>
  )
}

export default PaymentMethod
